import React, { useState, useMemo } from 'react';
import { Search, Tag, ShieldOff } from 'lucide-react';

const CAMPAIGN_DATA = [
  {
    campaign: 'SRCH_BRND_Yenilio',
    label: 'Yenilio (Brand)',
    keywords: [
      'yenilio', 'yenilio.com', '[yenilio.com]', '"yenilio"', '"yenilio teknoloji"', '[yenilio teknoloji]', 'yeniliocom',
    ],
  },
  {
    campaign: 'SRCH_GNRC_iPhone_11',
    label: 'iPhone 11',
    keywords: [
      '"iphone 11 128 gb fiyat"', '"iphone 11 ikinci el"', '"iphone 11 2 el"', '"en ucuz iphone 11"',
      '"ikinci el iphone 11"', '"ayfon 11 ikinci el"', '"letgo iphone 11"', '"sahibinden iphone 11"',
      '"iphone 11 128"', '"2 el iphone 11"', '"Uygun fiyatlı iPhone 11"', '"iphone 11 fiyat 128 gb"',
      '"iphone 11 en uygun fiyat 128 gb"', '"iphone 11 ikinci el fiyatları"', '"ayfon 11 128 gb fiyat"',
      '"iphone 11 2 el fiyat"', '"iphone 11 2 el letgo"', '"iphone 11 sahibinden"',
      '"İkinci el iPhone 11"', '"Garantili iPhone 11"', '"iphone 11 letgo"', '"iphone 11 64 gb fiyat 2 el"',
      '"iphone 11 pro ikinci el"', '"iphone 11 pro 2 el"', '"İkinci el iPhone 11 pro"',
      '"11 pro max"', '"11 pro max fiyat"', '"apple 11 pro max"', '"iphone 11 pro max fiyat"',
      '"iphone 11 pro max ikinci el"', '"iphone 11 pro max 128 gb"', '"iphone 11 pro max fiyatı"',
      '"iphone 11 pro max fiyatları"', '"iphone 11 pro max 256 gb fiyat"',
    ],
    negatives: [
      '[iphone 11 pro max 2 el]', '[iphone 11 pro 2 el]', '[2 el iphone 11 pro]',
      '[2 el iphone 11 pro max]', '[ikinci el iphone 11 pro]', '[ikinci el iphone 11 pro max]',
      '[iphone 11 pro max 2 el letgo]', '[iphone 11 pro max 2 el sahibinden]',
      '[iphone 11 pro ikinci el]', '[iphone 11 pro ikinci el fiyatları]',
      '[kaçak iphone 11 pro max]', '[kaçak iphone 11 pro fiyat]', '[kaçak 11 pro fiyat]',
      '[iphone 11 pro max yurtdışı]', '[iphone 11 pro max yurtdışı fiyatı]',
      '[iphone 11 pro max yurtdışı fiyatı sahibinden]', '[iphone 11 pro sahibinden istanbul]',
      '[sahibinden 11 pro]', '[letgo iphone 11 pro max]',
      '[iphone 11 kaçak fiyatı 2023]', '[iphone 11 ikinci el yurtdışı]',
      '[iphone 11 pro 128 gb fiyat]', '[iphone 11 pro 128 gb]',
      '[iphone 11 128 gb fiyat teknosa]', '[teknosa iphone 11 128 gb]', '[teknosa iphone 11 pro 128 gb]',
      '[trendyol iphone 11 128 gb]', '[media markt iphone 11 128 gb]',
      '[iphone 11 mini 128 gb fiyat]', '[iphone 11 mini 2 el]',
      '[iphone 11 pro max yenilenmiş]', '[iphone 11 pro yenilenmiş]',
      '[yenilenmiş iphone 11 128 gb]', '[iphone 11 yurtdışı sahibinden]',
      '[11 pro maks]', '[11 pro maks fiyat]',
      '[ıphone 14 pro ikinci el]',
      '"garantili cep"',
    ]
  },
  {
    campaign: 'SRCH_GNRC_iPhone_13',
    label: 'iPhone 13',
    keywords: [
      '"iphone 13 ikinci el"', '"ikinci el iphone 13"', '"iphone 13 yenilenmiş"', '"yenilenmiş iphone 13"',
      '"2 el iphone 13"', '"iphone 13 2 el"', '"iphone 13 fiyat yenilenmiş"', '"iphone 13 fiyat ikinci el"',
      '"İkinci el Apple ürünleri"', '"apple 13 ikinci el fiyatları"', '"Uygun fiyatlı iPhone 13"',
      '"Garantili iPhone 13"', '"letgo iphone 13"', '"sahibinden ikinci el iphone 13"',
      '"iphone 13 2 el sahibinden"', '"iphone 13 ikinci el fiyatı"', '"iphone 13 ikinci el fiyatları"',
      '"iphone 13 pro ikinci el"', '"iphone 13 pro 2 el"', '"iphone 13 pro yenilenmiş"',
      '"Yenilenmiş iPhone 13 pro"', '"2 el iphone 13 pro"', '"13 pro ikinci el"',
      '"iphone 13 pro max ikinci el"', '"iphone 13 pro max 2 el fiyatları"', '"yenilenmiş iphone 13 pro max"',
      '"İkinci el iPhone 13 pro max"', '"13 pro max ikinci el"', '"2 el iphone 13 pro max"',
    ],
    negatives: [
      '[iphone 11]', '[iphone 11 fiyat]', '[iphone 11 fiyatları]', '[iphone 11 2 el]',
      '[iphone 11 2 el fiyat]', '[iphone 11 sahibinden]', '[ikinci el iphone 11]',
      '[iphone 11 pro fiyat]', '[yenilenmiş iphone 11 pro max]', '[yepy iphone 11]',
      '[iphone 12 yenilenmiş]', '[iphone 12 mini yenilenmiş]', '[iphone 12 pro max yenilenmiş]',
      '[yenilenmiş iphone 12 mini]', '[iphone 12 128 gb fiyat]', '[iphone 12 128 2 el]',
      '[iphone 12 2 el]', '[iphone 12 sifir fiyat]', '[iphone 12 fiyat yenilenmiş]',
      '[iphone 14]', '[iphone 14 pro]', '[iphone 14 pro max]', '[iphone 14 plus]',
      '[iphone 14 2 el]', '[2 el iphone 14]', '[iphone 14 ikinci el]', '[iphone 14 taksitli]',
      '[apple iphone 14 pro max]', '[iphone 14 fiyat pro]',
      '[iphone 14 pro easycep]', '[iphone 14 pro getmobil]',
      '[iphone 13 pro max replika sahibinden]', '[sahibinden iphone 13 pro]',
      '[iphone 13 pro max yurtdışı fiyatı ikinci el]',
      '[iphone 113]', '[iphone 113 pro]', '[iphone 113 128 gb]', '[iphone 11 13]',
      '"garantili cep"',
    ]
  },
  {
    campaign: 'SRCH_GNRC_iPhone_14',
    label: 'iPhone 14',
    keywords: [
      '"İkinci el iPhone 14"', '"Yenilenmiş iPhone 14"', '"İkinci el Apple ürünleri"',
      '"iphone 14 ikinci el fiyatları"', '"ikinci el ıphone 14"', '"sahibinden 2 el iphone 14"',
      '"Garantili iPhone 14"', '"14 iphone ikinci el"', '"letgo iphone 14 ikinci el"',
      '"İkinci el iPhone 14 pro"', '"Yenilenmiş iPhone 14 pro"', '"sahibinden iphone 14 pro"',
      '"sahibinden 2 el iphone 14 pro"', '"Garantili iPhone 14 pro"',
      '"iphone 14 pro max ikinci el"', '"İkinci el iPhone 14 pro max"', '"sahibinden iphone 14 pro max"',
      '"Yenilenmiş iPhone 14 pro max"', '"ayfon 14 pro max ikinci el"',
    ],
    negatives: [
      '[iphone 11 yenilenmiş]', '[yenilenmiş iphone 11]', '[yenilenmiş iphone 11 128 gb]',
      '[iphone 11 yenilenmiş 128 gb]', '[iphone 11 yenilenmiş cihaz]', '[iphone 11 yenilenmiş 2 el]',
      '[yenilenmiş iphone 11 cimri]', '[yenilenmiş iphone 11 fiyat]', '[yenilenmiş iphone 11 ne kadar]',
      '[yenilenmiş iphone 11 64 gb fiyat]', '[yenilenmiş iphone 11 128 gb a kalite]',
      '[yenilenmiş iphone 11 pro]', '[yenilenmiş iphone 11 pro max 128 gb]',
      '[iphone 11 128 gb fiyat yenilenmiş]', '[iphone 11 fiyat yenilenmiş]',
      '[iphone 11 pro yenilenmiş]', '[iphone 11 pro max yenilenmiş]',
      '[iphone 11 ikinci el kaç lira]', '[iphone 11 ikinci el teknosa]', '[iphone 11 mor 2 el]',
      '[iphone 12 yenilenmiş]', '[yenilenmiş iphone 12]', '[iphone 12 mini yenilenmiş]',
      '[iphone 12 pro yenilenmiş]', '[iphone 12 pro max yenilenmiş]',
      '[yenilenmiş iphone 12 mini]', '[yenilenmiş iphone 12 pro]', '[yenilenmiş iphone 12 fiyat]',
      '[iphone 12 128 yenilenmiş]', '[iphone 12 ikinci el teknosa]',
      '[teknosa iphone 12 mini yenilenmiş]', '[media markt yenilenmiş iphone 12]',
      '[iphone 13 yenilenmiş]', '[yenilenmiş iphone 13]', '[iphone 13 pro yenilenmiş]',
      '[yenilenmiş iphone 13 pro]', '[yenilenmiş iphone 13 pro max]', '[yenilenmiş iphone 13 fiyat]',
      '[iphone 13 ikinci el teknosa]', '[teknosa ikinci el iphone 13]', '[iphone 13 2 el teknosa]',
      '[getmobil yenilenmiş iphone 13]', '[media markt iphone 13 yenilenmiş]',
      '[ıphone 14 pro ikinci el]', '[iphone 14 pro ikinci el]', '[ikinci el iphone 14 pro]',
      '[iphone 14 pro max ikinci el]', '[ıphone 14 pro max ikinci el]',
      '[iphone 14 pro max ikinci el sahibinden]', '[iphone 14 pro max ikinci el fiyatları]',
      '[iphone 14 pro max replika sahibinden]',
      '[iphone 14 pro max yurtdışı sahibinden]', '[iphone 14 pro max sahibinden yurtdışı]',
      '[iphone 14 pro yenilenmiş]', '[iphone 14 plus yenilenmiş]',
      '[yenilenmiş telefon iphone 14 pro max]',
      '"garantili cep"',
    ]
  },
  {
    campaign: 'SRCH_GNRC_iPhone_15',
    label: 'iPhone 15',
    keywords: [
      '"iphone 15 ikinci el fiyatları"', '"Garantili iPhone 15"', '"Yenilenmiş iPhone 1"',
      'iphone 15 pro taksitli', '"Garantili iPhone 15 pro"',
    ],
    negatives: [
      '[iphone 11 yenilenmiş]', '[yenilenmiş iphone 11]', '[yenilenmiş iphone 11 128 gb]',
      '[iphone 11 yenilenmiş 128 gb]', '[iphone 11 yenilenmiş cihaz]', '[iphone 11 yenilenmiş 2 el]',
      '[yenilenmiş iphone 11 cimri]', '[yenilenmiş iphone 11 fiyat]',
      '[yenilenmiş iphone 11 pro]', '[iphone 11 pro max yenilenmiş]', '[iphone 11 pro yenilenmiş]',
      '[iphone 11 ikinci el kaç lira]', '[iphone 11 ikinci el teknosa]', '[iphone 11 mor 2 el]',
      '[iphone 12 yenilenmiş]', '[yenilenmiş iphone 12]', '[iphone 12 mini yenilenmiş]',
      '[yenilenmiş iphone 12 mini]', '[iphone 12 pro yenilenmiş]', '[iphone 12 pro max yenilenmiş]',
      '[yenilenmiş iphone 12 pro]', '[yenilenmiş iphone 12 fiyat]',
      '[iphone 12 128 yenilenmiş]', '[iphone 12 ikinci el teknosa]',
      '[iphone 13 yenilenmiş]', '[yenilenmiş iphone 13]', '[iphone 13 pro yenilenmiş]',
      '[yenilenmiş iphone 13 pro]', '[yenilenmiş iphone 13 pro max]',
      '[yenilenmiş iphone 13 fiyat]', '[yenilenmiş iphone 13 128 gb]',
      '[iphone 13 ikinci el teknosa]', '[iphone 13 2 el teknosa]',
      '[getmobil yenilenmiş iphone 13]', '[media markt yenilenmiş iphone 13]',
      '[iphone 14 pro ikinci el]', '[ıphone 14 pro ikinci el]', '[ikinci el iphone 14 pro]',
      '[iphone 14 pro max ikinci el]', '[ıphone 14 pro max ikinci el]',
      '[iphone 14 pro max ikinci el sahibinden]', '[iphone 14 pro max ikinci el fiyatları]',
      '[iphone 14 pro yenilenmiş]', '[iphone 14 plus yenilenmiş]',
      '[iphone 14 pro max replika sahibinden]',
      '[iphone 14 pro max yurtdışı sahibinden]', '[iphone 14 pro max sahibinden yurtdışı]',
      '[yenilenmiş telefon iphone 14 pro max]',
      '"garantili cep"',
    ]
  },
  {
    campaign: 'SRCH_GNRC_COMP',
    label: 'Rakip Markalar',
    keywords: [
      '"getmobil"', '"get mobil"', '"easycep"', '"izi cep"', '"izicep"', '"hb bilişim"', '"hbbilisim"',
      '"mobilfon"', '"garantili cep"', '"easy cep telefonu"',
      '"getmobil iphone 13"', '"easycep iphone"', '"iphone easycep"', '"iphone 13 easycep"',
      '"getmobil iphone 14"', '"easycep iphone 11"', '"iphone 11 getmobil"',
      '"hb bilişim iphone"', '"hb telefon"', '"easycep taksitli telefon"', '"easycep telefon al"',
      '"getmobil 12 ay taksit"', '"easycep 12 ay taksit"',
      'getmobile', 'getmobile iphone', 'getmobile yenilenmiş telefon',
    ],
    negatives: [
      '[easycep güvenilir mi]', '[easycep taksit var mı]', '[samsung s22 ultra easycep]',
      '[getmobil güvenilir mi]', '[getmobil ekşi]', '[getmobil yorumlar]',
      '[getmobil telefon alınır mı]', '[getmobil iletişim]', '[getmobil samsung]',
      '[getmobil mı easycep mı]',
      '[hb bilişim güvenilir mi]', '[hb bilişim yorumlar]', '[hb iletişim]',
      '[yenilenmiş iphone 8]', '[teknosa yenilenmiş iphone 12]',
      '[iphone 12 pro yenilenmiş]', '[iphone 14 pro yenilenmiş]', '[iphone 14 yenilenmiş]',
      '[iphone 14 pro max yenilenmis]', '[iphone 15 pro max yenilenmiş]',
      '[yenilenmiş iphone 12 pro max 128 gb]',
      '[kvk garantili iphone]', '[kvk garantili samsung cep telefonları]',
      '[ithalatçı garantili iphone]', '[türkiyede garantisi olan iphone modelleri]',
      '[ikinci el cep telefonu garantili]', '[garantili tuşlu cep telefonları]',
      '[2 yıl garantili]', '[2 el garantili laptop]',
      '[redmi 12 pro 5g türkiye garantili]', '[redmi note 12 pro 5g ithalatçı garantili]',
      '[google pixel ithalatçı garantili]',
    ]
  },
  {
    campaign: 'SRCH_GNRC_Macbook',
    label: 'MacBook',
    keywords: [
      '"yenilenmis macbook"', '[yenilenmis macbook]', '"ikinci el macbook"', '[ikinci el macbook]', '"2 el macbook"',
      '"yenilenmis macbook air"', '[yenilenmis macbook air]', '"ikinci el macbook air"', '[ikinci el macbook air]',
      '"ikinci el macbook pro"', '[ikinci el macbook pro]', '[yenilenmis macbook pro]',
    ],
  },
];

const MATCH_COLORS = {
  Phrase: 'bg-blue-50 text-blue-700 border-blue-200',
  Exact: 'bg-purple-50 text-purple-700 border-purple-200',
  Broad: 'bg-amber-50 text-amber-700 border-amber-200',
};

const NEG_COLORS = {
  Phrase: 'bg-orange-50 text-orange-700 border-orange-200',
  Exact: 'bg-red-50 text-red-700 border-red-200',
  Broad: 'bg-rose-50 text-rose-600 border-rose-200',
};

function getMatchType(kw) {
  if (kw.startsWith('[')) return 'Exact';
  if (kw.startsWith('"')) return 'Phrase';
  return 'Broad';
}

const MAX_VISIBLE = 10;

export default function SearchKeywordReport() {
  const [searchQuery, setSearchQuery] = useState('');
  const [expandedPos, setExpandedPos] = useState({});
  const [expandedNeg, setExpandedNeg] = useState({});

  const togglePos = (id) => setExpandedPos(prev => ({ ...prev, [id]: !prev[id] }));
  const toggleNeg = (id) => setExpandedNeg(prev => ({ ...prev, [id]: !prev[id] }));

  const filteredData = useMemo(() => {
    const q = searchQuery.toLowerCase().trim();
    if (!q) return CAMPAIGN_DATA;
    return CAMPAIGN_DATA.map(c => ({
      ...c,
      keywords: c.keywords.filter(kw => kw.toLowerCase().includes(q) || c.label.toLowerCase().includes(q)),
      negatives: c.negatives
        ? c.negatives.filter(kw => kw.toLowerCase().includes(q) || c.label.toLowerCase().includes(q))
        : undefined,
    })).filter(c => c.keywords.length > 0 || (c.negatives && c.negatives.length > 0));
  }, [searchQuery]);

  const totalKeywords = useMemo(() => filteredData.reduce((s, c) => s + c.keywords.length, 0), [filteredData]);
  const totalNegatives = useMemo(() => filteredData.reduce((s, c) => s + (c.negatives ? c.negatives.length : 0), 0), [filteredData]);

  return (
    <div className="min-h-screen p-4 md:p-6 space-y-6 max-w-screen-2xl mx-auto bg-[#f6f8ff]/70">
      <div className="bg-white p-5 rounded-2xl shadow-sm border border-gray-100">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div className="flex items-center gap-4">
            <div className="p-3 bg-blue-50 border border-blue-100 shadow-sm rounded-xl">
              <img src="/google_ads.webp" alt="Google Ads" className="w-8 h-8 object-contain" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Search Keyword Report — Yenilio</h1>
              <p className="text-sm text-gray-500 mt-0.5">Yenilio — Kampanya bazlı keyword & negatif dağılımı</p>
            </div>
          </div>
          <div className="flex items-center gap-3 text-sm flex-wrap">
            <span className="px-3 py-1.5 bg-blue-50 text-blue-700 rounded-lg font-medium">{filteredData.length} Kampanya</span>
            <span className="px-3 py-1.5 bg-emerald-50 text-emerald-700 rounded-lg font-medium">{totalKeywords} Keyword</span>
            <span className="px-3 py-1.5 bg-red-50 text-red-700 rounded-lg font-medium">{totalNegatives} Negatif</span>
          </div>
        </div>
      </div>

      <div className="relative">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="text"
          placeholder="Keyword veya kampanya ara..."
          className="w-full pl-11 pr-4 py-3 bg-white border border-gray-200 rounded-2xl text-sm shadow-sm focus:ring-2 focus:ring-blue-100 focus:border-blue-300 outline-none transition-all"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {filteredData.map((c) => {
          const isPosExpanded = expandedPos[c.campaign];
          const isNegExpanded = expandedNeg[c.campaign];
          const visibleKw = isPosExpanded ? c.keywords : c.keywords.slice(0, MAX_VISIBLE);
          const hiddenKw = c.keywords.length - MAX_VISIBLE;
          const negs = c.negatives || [];
          const visibleNeg = isNegExpanded ? negs : negs.slice(0, MAX_VISIBLE);
          const hiddenNeg = negs.length - MAX_VISIBLE;

          return (
            <div key={c.campaign} className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 flex flex-col">
              <div className="flex items-center justify-between mb-4">
                <div>
                  <h2 className="font-semibold text-gray-900 text-base">{c.label}</h2>
                  <p className="text-xs text-gray-400 mt-0.5">
                    {c.keywords.length} keyword{negs.length > 0 && ` · ${negs.length} negatif`}
                  </p>
                </div>
                <div className="flex items-center gap-1.5">
                  <span className="text-xs px-2.5 py-1 bg-emerald-50 text-emerald-600 rounded-full font-medium">{c.keywords.length}</span>
                  {negs.length > 0 && (
                    <span className="text-xs px-2.5 py-1 bg-red-50 text-red-600 rounded-full font-medium">-{negs.length}</span>
                  )}
                </div>
              </div>

              {c.keywords.length > 0 && (
                <div className="flex flex-wrap gap-1.5">
                  {visibleKw.map((kw, i) => {
                    const mt = getMatchType(kw);
                    return (
                      <span key={i} className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-md border text-xs font-medium ${MATCH_COLORS[mt]}`}>
                        <Tag className="w-3 h-3 flex-shrink-0 opacity-50" />
                        {kw}
                      </span>
                    );
                  })}
                </div>
              )}
              {hiddenKw > 0 && (
                <button
                  onClick={() => togglePos(c.campaign)}
                  className="mt-2 text-xs text-blue-600 hover:text-blue-800 font-medium flex items-center gap-1 transition-colors self-start"
                >
                  {isPosExpanded ? 'Gizle' : `+${hiddenKw} keyword daha göster`}
                  <svg className={`w-3.5 h-3.5 transition-transform ${isPosExpanded ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                </button>
              )}

              {negs.length > 0 && (
                <>
                  <div className="mt-4 mb-3 flex items-center gap-2">
                    <div className="h-px flex-1 bg-red-100"></div>
                    <span className="text-[10px] font-semibold text-red-400 uppercase tracking-wider flex items-center gap-1">
                      <ShieldOff className="w-3 h-3" /> Negatif Keywordler
                    </span>
                    <div className="h-px flex-1 bg-red-100"></div>
                  </div>
                  <div className="flex flex-wrap gap-1.5">
                    {visibleNeg.map((kw, i) => {
                      const mt = getMatchType(kw);
                      return (
                        <span key={i} className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-md border text-xs font-medium ${NEG_COLORS[mt]}`}>
                          <ShieldOff className="w-3 h-3 flex-shrink-0 opacity-50" />
                          {kw}
                        </span>
                      );
                    })}
                  </div>
                  {hiddenNeg > 0 && (
                    <button
                      onClick={() => toggleNeg(c.campaign)}
                      className="mt-2 text-xs text-red-500 hover:text-red-700 font-medium flex items-center gap-1 transition-colors self-start"
                    >
                      {isNegExpanded ? 'Gizle' : `+${hiddenNeg} negatif daha göster`}
                      <svg className={`w-3.5 h-3.5 transition-transform ${isNegExpanded ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                    </button>
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>

      {filteredData.length === 0 && (
        <div className="bg-white rounded-2xl p-12 text-center shadow-sm border border-gray-100">
          <Search className="w-12 h-12 text-gray-300 mx-auto mb-3" />
          <h3 className="text-lg font-medium text-gray-700">Sonuç bulunamadı</h3>
          <p className="text-sm text-gray-500 mt-1">Arama terimini değiştirmeyi dene</p>
        </div>
      )}

      <div className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-gray-500">
          <span className="font-medium text-gray-600">Pozitif:</span>
          <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-blue-100 border border-blue-200"></span> Phrase</span>
          <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-purple-100 border border-purple-200"></span> Exact</span>
          <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-amber-100 border border-amber-200"></span> Broad</span>
          <span className="mx-1 text-gray-300">|</span>
          <span className="font-medium text-gray-600">Negatif:</span>
          <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-orange-100 border border-orange-200"></span> Phrase</span>
          <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-red-100 border border-red-200"></span> Exact</span>
          <span className="flex items-center gap-1.5"><span className="w-3 h-3 rounded bg-rose-100 border border-rose-200"></span> Broad</span>
        </div>
      </div>
    </div>
  );
}
